import { render } from "./FormDualComponent.vue?vue&type=template&id=174eb34e&scoped=true"
import script from "./FormDualComponent.vue?vue&type=script&lang=js"
export * from "./FormDualComponent.vue?vue&type=script&lang=js"

import "./FormDualComponent.vue?vue&type=style&index=0&id=174eb34e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-174eb34e"]])

export default __exports__